import styles from "./description.module.scss";
import { DescriptionType, DescriptionVariant } from "./description.types";
import parse from "html-react-parser";

export const DescriptionElement = (item: DescriptionType) => {
  switch (item.type) {
    case DescriptionVariant.HEADER:
      return <h2 className={styles.title}>{item.data.text}</h2>;

    case DescriptionVariant.QUOTE:
      return <q>{parse(item.data.text)}</q>;

    case DescriptionVariant.PARAGRAPH:
      return <p className={styles.paragraph}>{parse(item.data.text)}</p>;

    case DescriptionVariant.DELIMITER:
      return <div className={styles.delimiter}>***</div>;

    case DescriptionVariant.LIST:
      return (
        <ul className={styles.list}>
          {item.data.items?.map((listItem, index) => {
            if (typeof listItem === "string") {
              return <li key={index}>{parse(listItem)}</li>;
            }
          })}
        </ul>
      );
    default:
      return null;
  }
};
